<template>
  <div class="modal">
    <v-card class="delivery-card">
      <p class="title">TEXT DELIVERY TEMPLATE </p>
      <div class="list-item">
        <div :class="`item ${value === 'ORDER' ? 'active' : ''}`">
          <p class="text-type">ORDER</p>
          <p>Hi Ultranian. Terima kasih atas pesanannya dari</p>
          <p class="text-bold">"Nama Perusahaan".</p>
          <br />
          <p>Untuk detail dari pesanan Anda,</p>
          <p>Silahkan klik <span class="text-bold">"URL Redeem Link"</span></p>
          <p class="text-bold">"PIN: xxxx"</p>
          <br/>
          <p>Note: <span class="text-bold">"Nama Perusahaan"</span> dan Ultra Voucher tidak pernah meminta data pribadi pelanggan dan waspada terhadap segala penipuan yang mengatasnamakan perusahaan.</p>
        </div>

        <div :class="`item ${value === 'GIFT' ? 'active' : ''}`">
          <p class="text-type">GIFT</p>
          <p>Hi Ultranian. Selamat Anda mendapatkan hadiah dari</p>
          <p class="text-bold">"Nama Perusahaan".</p>
          <br />
          <p>Untuk detail hadiah Anda,</p>
          <p>Silahkan klik <span class="text-bold">"URL Redeem Link"</span></p>
          <p class="text-bold">"PIN: xxxx"</p>
          <br/>
          <p>Note: <span class="text-bold">"Nama Perusahaan"</span> dan Ultra Voucher tidak pernah meminta data pribadi pelanggan dan waspada terhadap segala penipuan yang mengatasnamakan perusahaan.</p>
        </div>
      </div>
      <button class="close-btn" @click="$emit('close')">Close</button>
    </v-card>
  </div>
</template>

<script>
export default {
  name: 'DeliveryMethodTemplate',
  props: {
    value: {
      type: String,
      default: ''
    }
  }
}
</script>

<style scoped>
p {
  margin-bottom: 0;
}
.modal {
  position: fixed;
  top: 0;
  right: 0;
  width: 100%;
  height: 100%;
  background: #69696980;
  z-index: 500;
  display: flex;
  justify-content: center;
  align-items: center;
}

.delivery-card {
  width: 90%;
  padding: 40px;
  border-radius: 10px;
}

.title {
  color: #404040;
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  margin-bottom: 2rem;
}
.list-item {
  display: flex;
  gap: 30px;
}
.item {
  padding: 20px;
  border: 2px solid #676767;
  background: #FFF;
  color: #404040;
  border-radius: 10px;
  text-align: start;
}
.item.active {
  border: 3px solid #009A46;
  background: #F1FFF7;
}

.text-type {
  color: #009A46;
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  letter-spacing: 0.4px;
  text-transform: capitalize;
  margin-bottom: 1rem;
}

.text-bold {
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  letter-spacing: 0.28px;
}

.close-btn {
  display: flex;
  justify-content: center;
  background: #009A46;
  color: #fff;
  margin-left: auto;
  margin-top: 1rem;
  width: 230px;
  padding: 12px 0;
  border-radius: 5px !important;
}
</style>
